
import QReleaseSetting from "@/components/common/qReleaseSetting.vue";
import { STATUS_LIVE } from "@/model/releaseSetting";
import { Component } from "vue-property-decorator";

@Component({
  name: "qReleaseSettingLive",
})
export default class QReleaseSettingLive extends QReleaseSetting {
  public statusList = STATUS_LIVE;
}
